import styled from '@emotion/styled';

const ContentBox = styled.div`
  margin: 0px auto;
  padding: 15px;
  max-width: 900px;
  background-color: ${props =>
    props.solidBackground ? props.theme.backgroundDarkSemiTransparent : `none`};
  border-radius: ${props => props.theme.radius};
  color: ${props => props.theme.text};
`;

export { ContentBox };
